export const breakpoint = {
    defaut: 0,
    mobile: 320,
    smartphone: 400,
    tablet: 640,
    sidebar: 960, // breakpoint où la sidebar se positionne à gauche où à droite (si le site contient une sidebar...)
    desktop: 1024,
    large: 1440,
    xlarge: 1680,
    wide: 1921, // breakpoint pour les écrans extra larges
};
